/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EncryptionAlgorithmEnum } from './encryptionAlgorithmEnum';
import { EncryptionKeyFormat } from './encryptionKeyFormat';


export interface GetPublicKeyResponseSpec { 
    algorithm?: EncryptionAlgorithmEnum;
    key_format?: EncryptionKeyFormat;
    /**
     * Public key of public/private key pair
     */
    public_key?: string;
}
export namespace GetPublicKeyResponseSpec {
}


